import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { reducers } from './index.reducers';
import { provideEffects } from '@ngrx/effects';
import { effects } from './index.effects';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), provideAnimations(), importProvidersFrom(HttpClientModule), provideStore(reducers), provideEffects(effects)]
};
